import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-marketing',
  standalone: true,
  templateUrl: '../../assets/marketing.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamMarketingIcon {}
